<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="row">
        <div class="col-sm-6 graph-box">
          <div class="col-sm-12 graph-box">
            <SPRequirementStatus :requirementsstatus="requirementsstatus"></SPRequirementStatus>
          </div>
        </div>
        <div class="col-sm-6 graph-box">
          <SPHumanResources :humanresources="humanresources"></SPHumanResources>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 graph-box">
          <SPDossiers :dossiers="dossiers"></SPDossiers>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SPRequirementStatus from '@/components/SPRequirementStatus.vue'
import SPHumanResources from '@/components/SPHumanResources.vue'
import SPDossiers from '@/components/SPDossiers.vue'

import axios from 'axios';

export default {
  data: function() {return {
    service_provider_id:'',
    serviceprovider:{},
    requirementsstatus:{},
    humanresources:{},
    dossiers:{},
  }},


  components: {
    SPRequirementStatus,
    SPHumanResources,
    SPDossiers,
  },
  methods: {

    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/service_provider_tdb.php',
          { params: {service_provider_id: this.$route.params.service_provider_id}})
        .then(response => {
          this.$checkApiErrors(response.data);
          this.serviceprovider = response.data.serviceprovider;
          this.requirementsstatus = response.data.requirementsstatus;
          this.humanresources = response.data.humanresources;
          this.dossiers = response.data.dossiers}
        )
    },
    

  },
  mounted () {
    this.refresh();
    this.service_provider_id=this.$route.params.service_provider_id;
  }
}
</script>
